module.exports = __webpack_public_path__ + "assets/img/923023.bba18ed6.jpg";